import { useTranslation } from 'react-i18next'
import { SubscriptionInterval } from '@/constants/wizard'
import { Toggle } from '@/components/ui/Toggle'

interface SubscriptionToggleProps {
  interval: SubscriptionInterval
  onIntervalChange: (interval: SubscriptionInterval) => void
}

export function SubscriptionToggle({ interval, onIntervalChange }: SubscriptionToggleProps) {
  const { t } = useTranslation('wizard')
  const isMonthly = interval === SubscriptionInterval.MONTHLY

  const handleCheckedChange = (checked: boolean) => {
    onIntervalChange(checked ? SubscriptionInterval.YEARLY : SubscriptionInterval.MONTHLY)
  }

  return (
    <Toggle
      leftLabel={t('toggle.monthly')}
      rightLabel={t('toggle.yearly')}
      checked={!isMonthly}
      onCheckedChange={handleCheckedChange}
      aria-label={t(isMonthly ? 'toggle.yearly' : 'toggle.monthly')}
    />
  )
}
